import { useFormContext } from 'react-hook-form';
import { AccountPortfolioDTO } from '../../../../../../api/useAccountPortfolioQuery';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const useAssetAllocation = (accountPortfolio?: AccountPortfolioDTO) => {
  const {
    options: { DefaultAssetAllocation: defaultAccountPortfolio },
  } = useAccountFormContext();

  const { watch } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const assetAllocationSettings =
    accountPortfolio ||
    defaultAccountPortfolio.find(({ AccountType }) => AccountType === accountType);

  if (!assetAllocationSettings) {
    throw new Error('Unable to find asset allocation settings for account type');
  }

  return {
    data: {
      showHypotheticalReturn: assetAllocationSettings.ShowHypotheticalReturn,
    },
  };
};
